<div
	cdkScrollable
	[id]="id"
	class="modal"
	tabindex="-1"
	role="dialog"
	data-keyboard="false"
	data-backdrop="static"
	>
	<div class="modal-dialog {{ modalSize }}" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<button *ngIf="windowCloseButton" type="button" class="close" (click)="closeRequested()" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
				<h1 *ngIf="htmlTitle" [innerHtml]="htmlTitle"></h1>
				<h1 *ngIf="!htmlTitle">{{ title }}</h1>
			</div>
	
			<div class="modal-body">
				<ng-content></ng-content>
			</div>
	 	</div>
	</div>
</div>